// extracted by mini-css-extract-plugin
module.exports = {"warning":"warning_button-module__warning--2Sn_e"};